// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>33</span>&nbsp;&nbsp;&#145;But I will not take from him my steadfast love&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;nor suffer my truth to fail.<br> </p> </div></div>";
// Exports
module.exports = code;